module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-new-york.c7506780.png";